import React from 'react';
import { motion } from 'framer-motion';
const weeks = [{
  num: 1,
  title: 'Semana 1 · Diagnóstico',
  desc: 'Identificá el bloqueo real. No corrijas, solo observá y anotá lo que ves usando el Escáner del Tomo 1.'
}, {
  num: 2,
  title: 'Semana 2 · Entrenamiento',
  desc: 'Empezá con el Gimnasio Ocular sin presión académica. El objetivo es que los ojos aprendan a moverse diferente.'
}, {
  num: 3,
  title: 'Semana 3 · Práctica Guiada',
  desc: 'Introducí el Método de Bloques. Sesiones de 10 minutos máximo. Un texto a la vez.'
}, {
  num: 4,
  title: 'Semana 4 · Consolidación',
  desc: 'Repasá y celebrá los avances, sin importar el tamaño. La celebración es parte del aprendizaje.'
}];
export function ThirtyDayPlan() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-314">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-315">
        <div className="text-center mb-8" data-id="element-316">
          <span className="text-slate-500 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-317">
            Tu plan de acción
          </span>
          <h2 className="text-3xl font-bold mb-4 text-navy" data-id="element-318">
            Los Próximos 30 Días
          </h2>
          <p className="text-slate-600" data-id="element-319">
            Un camino simple, semana a semana. No necesitás hacerlo perfecto —
            necesitás hacerlo consistente.
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-320">
          {weeks.map((w, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex gap-4 bg-slate-50 p-4 rounded-xl border border-slate-100" data-id="element-321">
              <div className="w-8 h-8 rounded-full bg-navy text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-322">
                {w.num}
              </div>
              <div data-id="element-323">
                <h3 className="font-bold text-navy mb-1" data-id="element-324">{w.title}</h3>
                <p className="text-sm text-slate-600" data-id="element-325">{w.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-326">
          <p className="text-sm font-medium text-slate-500 italic" data-id="element-327">
            Recordá: no estás buscando que lea perfecto en 30 días. Estás
            buscando que deje de tenerle miedo.
          </p>
        </div>
      </div>
    </section>;
}